import { fetchAssetsByIds } from '../svp';

import { requestBlend } from './requestBlend';

import type { Provider } from '../../types';
import type { CurateFetchParams } from './requestBlend';

export type BlendItem = {
  type: 'video';
  id: number;
  provider: Provider;
  src: 'video';
};

export type BlendResponse = {
  items: BlendItem[];
};

export async function fetchAssetsFromBlend(
  provider: Provider,
  params: CurateFetchParams,
  signal?: AbortSignal
) {
  const assets = await requestBlend<BlendResponse>({
    provider,
    params,
    signal,
  });

  if (!assets || !assets.items || assets.items.length === 0) {
    return [];
  }

  return fetchAssetsByIds(
    assets.items.slice(0, 10).map(({ id }) => id),
    {},
    signal
  );
}
